import React from 'react';
import { FormSpy as FinalFormSpy } from 'react-final-form';
/**
 * Lightweight wrapper around the react-final-form
 * FormSpy component so that we can control selectively
 * how much of the API we are commited to.
 */
export var FormSpy = function FormSpy(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(FinalFormSpy, {
    subscription: {
      values: true
    }
  }, function (props) {
    return children({
      values: props.values
    });
  });
};